module.exports = __webpack_public_path__ + "img/back.e90f0b3f.png";